"use strict";

const socialAuthApiUrl = `${window.baseApiUrl}/accounts/social`;
const authFailMessageBase = 'autorizacija trenutno nije moguća.';

/**
 * Called by `modal-login` unicorn component `authenticate` method.
 * Sets given token to cookies,
 * calls 'item-profile' unicorn component `login` method that shows
 * logged in user avatar,
 * shows snackbar success message and
 * triggers `UserLoggedIn` that can be used for additional actions,
 * ie: Reload of page with premium paywall.
 */
function triggerLogin(token) {
  const expirationDate = window.getTokenExpirationDate(token);
  window.Cookies.set(window.jwtCookieKey, token, {
    expires: new Date(expirationDate),
    domain: window.getSiteDomain()
  });
  window.Unicorn.call('item-profile', 'login', token);
  window.showSnackbar('Bok! Tvoja prijava je uspješna!', 'success');
  document.dispatchEvent(new CustomEvent('UserLoggedIn', {
    detail: {
      token
    }
  }));
  document.dispatchEvent(new Event('pianoSetUserRef'));
  const successUrl = window.getSuccessUrl();
  if (successUrl) {
    document.addEventListener('setLoggedIn', () => {
      window.open(successUrl, '_self');
    });
  } else {
    /**
     * Upon user log in,
     * trigger reload of page after 1 second so
     * success login snackbar is shown.
     */
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
}

/**
 * Sends passed social token to API service url in order to retrieve
 * user's internal token for authorization.
 * Upon successful response, runs method for triggering user login,
 * otherwise, logs error and raises snackbar notification to user.
 */
window.socialLogin = async (vendor, token) => {
  window.showGeneralLoader();
  const apiUrl = `${socialAuthApiUrl}/${vendor.toLowerCase()}`;
  const socialLoginResponse = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      access_token: token,
      privacy_policy: true
    })
  });
  const socialLoginData = await socialLoginResponse.json();
  if (socialLoginResponse.status === 200) {
    triggerLogin(socialLoginData.token);
  } else {
    console.error(`[Social Login] Api for social login (${vendor}) did not return token. ` + `Status: ${socialLoginResponse.status}. Please see "${apiUrl}" response.`);
    if (socialLoginResponse.json().errors) {
      window.showLoginErrors(socialLoginResponse.json());
    } else {
      window.hideGeneralLoader();
      window.showSnackbar(`${vendor} ${authFailMessageBase}`, 'error');
    }
  }
};

/**
 * Initializes Facebook login button that can be used on login
 */
window.loginInitializeFacebook = () => {
  const facebookButton = document.querySelector('.btn--facebook');
  facebookButton.addEventListener('click', () => {
    window.FB.login(facebookResponse => {
      if (facebookResponse.status === 'connected') {
        window.socialLogin('Facebook', facebookResponse.authResponse.accessToken);
      } else {
        window.hideGeneralLoader();
        window.showSnackbar(`Facebook ${authFailMessageBase}`, 'error');
      }
    }, {
      scope: 'public_profile,email'
    });
  });
};

/**
 * Initializes Google login button and One Tap mechanism which can be used on login.
 */
window.loginInitializeGoogle = () => {
  google.accounts.id.initialize({
    client_id: window.googleClientId,
    auto_select: true,
    itp_support: true,
    button_auto_select: true,
    callback: response => {
      window.socialLogin('Google', response.credential);
    }
  });
};

/**
 * Shows Google button and One Tap prompt.
 * `window.loginInitializeGoogle` must be called before in order
 * to this to work!
 */
window.showGoogleOneTap = () => {
  const googleBtnWrap = document.querySelector(".google_sign_in_wrap");
  google.accounts.id.renderButton(googleBtnWrap, {
    locale: "hr",
    text: "continue_with",
    width: "330",
    logo_alignment: "left"
  });
  google.accounts.id.prompt();
};

/**
 * Binds login event to shown elements.
 * Used upon show of modal login component, probably triggered by
 * `modal-login` unicorn component via `self.call`.
 */
window.bindLoginEvents = () => {
  const loginForm = document.querySelector('#login-form');
  if (loginForm) {
    loginForm.addEventListener('submit', e => {
      window.showGeneralLoader();
      window.Unicorn.call('modal-login', 'form_submit');
      e.preventDefault();
    });
  }

  // Facebook
  window.loginInitializeFacebook();

  // Google One Tap
  window.loginInitializeGoogle();
  window.showGoogleOneTap();
};

/**
 * Probably triggered by `modal-login` unicorn component via `self.call` 
 * upon errors from login API.
 */
window.showLoginErrors = errors => {
  if (errors.non_field_errors) {
    errors.non_field_errors.forEach(errorMessage => {
      window.showSnackbar(errorMessage, 'error');
    });
  }
  if (errors.detail) window.showSnackbar(errors.detail, 'error');
  if (errors.password) window.showSnackbar(errors.password, 'error');
  window.hideGeneralLoader();
};
document.addEventListener('BaseDataLoaded', () => {
  const userProfile = window.getProfileData();
  const successUrl = window.getSuccessUrl();
  if (!userProfile) {
    if (window.location.hash.startsWith('#prijava') || successUrl) {
      window.openModalLogin();
    }
  } else if (userProfile && userProfile.piano_subscription_type === 'subscriber' && successUrl) {
    window.open(successUrl, '_self');
  }
});